import React, { useEffect, useState } from "react";
import { Dialog } from "primereact/dialog";
import { Button } from "primereact/button";
import { MultiSelect } from "primereact/multiselect";
import { Checkbox } from "primereact/checkbox";

const WZListModal = ({ documents, onFilter }) => {
  const [open, setOpen] = useState(false);
  const [firma, setFirma] = useState("");
  const [odbiorca, setOdbiorca] = useState("");
  const [kopalnia, setKopalnia] = useState("");
  const [dataWystawienia, setDataWystawienia] = useState("");
  const [wydal, setWydal] = useState("");
  const [oplacono, setOplacono] = useState(false);

  const handleOpen = () => setOpen(true);
  const handleClose = () => setOpen(false);

  const handleApplyFilter = () => {
    onFilter({
        firma: firma.length > 0 ? firma : null,
        odbiorca: odbiorca.length > 0 ? odbiorca : null,
        egz: kopalnia.length > 0 ? kopalnia : null,
        wydal: wydal.length > 0 ? wydal : null,
    });
    handleClose();
  };

  const footer = (
    <div style={{marginTop: "1rem"}}>
      <Button
        label="Anuluj"
        icon="pi pi-times"
        onClick={handleClose}
        className="p-button-text"
      />
      <Button
        label="Zastosuj"
        icon="pi pi-check"
        onClick={handleApplyFilter}
        autoFocus
      />
    </div>
  );
      

  return (
    <>
      <Button icon="pi pi-filter" onClick={handleOpen} style={{ marginLeft: "10px", marginRight: "10px" }}/>
      <Dialog
        header="Filtruj dane"
        visible={open}
        style={{ width: "400px" }}
        footer={footer}
        onHide={handleClose}
      >
    
        <div className="p-field-modal">
          Firma
          <MultiSelect
            className="p-multiselect-modal"
            value={firma}
            options={[
              ...new Map(
                documents.map((doc) => {
                  const nazwa = JSON.parse(doc.firma).nazwa;
                  return [nazwa, { label: nazwa, value: nazwa }];
                })
              ).values(),
            ].sort((a, b) => a.label.localeCompare(b.label))}
            onChange={(e) => setFirma(e.value)}
            placeholder="Wybierz firmę"
          />
        </div>
        <div className="p-field-modal">
          Odbiorca
          <MultiSelect
            className="p-multiselect-modal"
            value={odbiorca}
            options={[
              ...new Map(
                documents.map((doc) => {
                  const nazwa = JSON.parse(doc.odbiorca).nazwa;
                  return [nazwa, { label: nazwa, value: nazwa }];
                })
              ).values(),
            ].sort((a, b) => a.label.localeCompare(b.label))}
            onChange={(e) => setOdbiorca(e.value)}
            placeholder="Wybierz odbiorcę"
          />
        </div>
        {/* <div className="p-field-modal">
          Przewoźnik
          <MultiSelect
            className="p-multiselect-modal"
            value={przewoznik}
            options={[
              ...new Map(
                documents.map((doc) => {
                  const nazwa = JSON.parse(doc.przewoznik).nazwa;
                  return [nazwa, { label: nazwa, value: nazwa }];
                })
              ).values(),
            ].sort((a, b) => a.label.localeCompare(b.label))}
            onChange={(e) => setPrzewoznik(e.value)}
            placeholder="Wybierz przewoźnika"
          />
        </div> */}
        <div className="p-field-modal">
          Kopalnia
          <MultiSelect
            className="p-multiselect-modal"
            value={kopalnia}
            options={[
              ...new Map(
                documents.map((doc) => {
                  const nazwa = JSON.parse(doc.egz).adres;
                  return [nazwa, { label: nazwa, value: nazwa }];
                })
              ).values(),
            ].sort((a, b) => a.label.localeCompare(b.label))}
            onChange={(e) => setKopalnia(e.value)}
            placeholder="Wybierz kopalnię"
          />
        </div>
        <div className="p-field-modal">
          Wydał
          <MultiSelect
            className="p-multiselect-modal"
            value={wydal}
            options={
                documents &&
                [...new Map(
                    documents.map((doc) => {
                      const nazwa = doc.wydal;
                      return [nazwa, { label: nazwa, value: nazwa }];
                    })
                  ).values()].sort((a, b) => a.label.localeCompare(b.label))
            }
            onChange={(e) => setWydal(e.value)}
            placeholder="Wybierz osobę"
          />
        </div>
      </Dialog>
    </>
  );
};

export default WZListModal;
